export function parseJwt (token) {
  const base64Url = token.split('.')[1]
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
  const jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
    return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
  }).join(''))
  return JSON.parse(jsonPayload)
}

export function getRole (token) {
  var parsedJWT = parseJwt(token)
  return parsedJWT.role
}

export function getName (token) {
  var parsedJWT = parseJwt(token)
  return parsedJWT.unique_name
}

export function getId (token) {
  var parsedJWT = parseJwt(token)
  return parsedJWT.nameid
}
